.bam-quick-link-nav__container {
  margin-bottom: 32px;

  @include tablet() {
    margin-bottom: 48px;
  }

  @include desktop() {
    margin-bottom: 80px;
  }
}

.bam-quick-link-nav__heading {
  @include mobile() {
    padding-bottom: 0 !important;
  }
}

.bam-quick-link-nav__card {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.bam-quick-link-nav__card-content bal-list {
  @include desktop() {
    flex-direction: row !important;
    flex-wrap: wrap;
  }
}

.bam-quick-link-nav__card-content bal-list bal-list-item {
  @include desktop() {
    flex: none !important;
    width: calc(50% - 30px) !important;

    &:nth-child(odd) {
      margin-right: 40px;
    }
  }
}
